<button [disabled]='disabled' (click)='click()' matTooltip='{{matTooltip}}'>
  <ng-content></ng-content>
</button>